<template>
  <div class="page_batchImportInv">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>收支</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/invoicing' }">结算单</el-breadcrumb-item>
          <el-breadcrumb-item>批量导入开票</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <div class="tips">提示：如批量开票属同一个项目、或同一个商务合同主体、或同一个开票抬头，可勾选下面选项，导入表相应字段可不填，系统将以勾选的为准</div>

        <div class="fillIn">
          <el-form ref="statementForm" :model="impForm" :rules="impRule" label-width="160px" label-position="left">
            <el-form-item>
              <template #label>
                <el-checkbox v-model="f1Enable" :true-label="1" :false-label="0" @change="changeEnable">指定项目或部门：</el-checkbox>
              </template>
              <div class="i_radio_box">
                <el-radio-group v-model="impForm.fillIn_1.type">
                  <el-radio :label="1">项目</el-radio>
                  <el-radio :label="2">内部部门</el-radio>
                </el-radio-group>
                <div class="i_box">
                  <el-select v-model="impForm.fillIn_1.ownershipId" v-if="impForm.fillIn_1.type == 1" placeholder="请选择项目" @change="getDetail" size="small" filterable clearable style="width: 180px">
                    <el-option v-for="item in projectList" :key="item.Id" :label="item.StrprojectName" :value="item.Projectid"></el-option>
                  </el-select>
                  <el-cascader v-if="impForm.fillIn_1.type == 2" v-model="dedpartDiaVal" size="small" :props="props" clearable filterable :options="departList" placeholder="请选择部门" @change="departChange" style="width: 180px"></el-cascader>
                </div>
              </div>
            </el-form-item>
            <el-form-item>
              <template #label>
                <el-checkbox v-model="f2Enable" :true-label="1" :false-label="0">指定商务合同主体：</el-checkbox>
              </template>
              <el-select v-model="impForm.fillIn_2.subjectOfLegalAffairsId" placeholder="" size="small" style="width: 220px" clearable filterable>
                <el-option v-for="(item, index) in legList" :key="index" :label="item.value" :value="item.key"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <el-form :inline="true" label-width="110px" :rules="impRule">
            <el-form-item label-width="130px">
              <template #label>
                <el-checkbox v-model="f3Enable" :true-label="1" :false-label="0" @change="changeEnable2">指定客户抬头：</el-checkbox>
              </template>
              <div class="i_radio_box">
                <el-radio-group v-model="titleType" @change="changeIsp">
                  <el-radio :label="1">选择开票抬头</el-radio>
                  <el-radio :label="2">使用新抬头</el-radio>
                  <el-radio :label="3">自然人开票</el-radio>
                </el-radio-group>
                <div class="i_box">
                  <el-select v-model="invoiceTitle" placeholder="" size="small" clearable filterable v-if="titleType == 1" @change="changeInvoiceTitle" value-key="id">
                    <el-option v-for="(item, index) in invoiceTitles" :key="index" :label="item.accountName" :value="item"></el-option>
                  </el-select>
                  <el-input v-model="impForm.fillIn_3.newInvoiceTitle" v-if="titleType == 2 || titleType == 3" @input="changeNewTitle" size="small" clearable></el-input>
                </div>
              </div>
            </el-form-item>
            <div style="padding-left: 80px;" v-if="f3Enable==1">
              <el-form-item label="纳税人识别号:" prop="fillIn_3.ratepayerNo">
                <el-input v-model="impForm.fillIn_3.ratepayerNo" size="small" clearable></el-input>
              </el-form-item>
              <el-form-item label="营业地址:">
                <el-input v-model="impForm.fillIn_3.businessAddress" size="small" clearable></el-input>
              </el-form-item>
              <el-form-item label="开户行:">
                <el-input v-model="impForm.fillIn_3.bankOfDeposit" size="small" clearable></el-input>
              </el-form-item>
              <el-form-item label="账号:">
                <el-input v-model="impForm.fillIn_3.accountNumber" size="small" clearable></el-input>
              </el-form-item>
              <el-form-item label="电话:">
                <el-input v-model="impForm.fillIn_3.telephone" size="small" clearable></el-input>
              </el-form-item>
            </div>
            <div>
              <el-form-item label-width="120px">
                <template #label>
                  <el-checkbox v-model="isPolymerization">是否合并开票 </el-checkbox>
                </template>
              </el-form-item>
            </div>
          </el-form>
          <div>
            <el-checkbox v-model="impForm.isConsolidatedBilling">服务费/管理费与工资/社保/个税合开在一张发票上（仅适用差额开票）</el-checkbox>
          </div>
        </div>

        <div class="r_act_item">
          <el-button size="small" type="warning" @click="batchImport">批量导入</el-button>
          <el-button size="small" type="success" @click="addLine">添加行</el-button>
          <!-- <el-button size="small" type="danger">删除行</el-button> -->
          <el-button size="small" type="primary">导出</el-button>
        </div>

        <el-table ref="multipleTable" class="doc_table" v-loading="tableLoading" @selection-change="handleSelectionChange" :max-height="tableHeight - 100" :data="tableData" style="width:100%;margin-top: 15px;" empty-text="暂无导入数据" border>
          <el-table-column key="mul" type="selection" width="55" align="center" fixed="left"></el-table-column>
          <el-table-column align="center" label="序号" width="60px" fixed="left">
            <template slot-scope="{$index}">{{ $index + 1 }}</template>
          </el-table-column>
          <el-table-column align="center" prop="name_OwnershipId" label="项目/部门" min-width="160px" fit :show-overflow-tooltip="true" fixed="left">
            <template slot-scope="{row}">
              <span :class="row.name_OwnershipId.indexOf('&\#')>-1 ? 'errTxt' : ''" v-if="row.name_OwnershipId">{{ row.name_OwnershipId.replace('&\#','') }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="name_TicketTypeId" label="开票类型" min-width="140px" fit :show-overflow-tooltip="true">
            <template slot-scope="{row}">
              <span :class="row.name_TicketTypeId.indexOf('&\#')>-1 ? 'errTxt' : ''" v-if="row.name_TicketTypeId">{{ row.name_TicketTypeId.replace('&\#','') }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="name_InvoiceItem" label="发票项目" min-width="100px" fit :show-overflow-tooltip="true">
            <template slot-scope="{row}">
              <span :class="row.name_InvoiceItem.indexOf('&\#')>-1 ? 'errTxt' : ''" v-if="row.name_InvoiceItem">{{ row.name_InvoiceItem.replace('&\#','') }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="name_BillingItemDetailsId" label="开票内容" min-width="140px" fit :show-overflow-tooltip="true">
            <template slot-scope="{row}">
              <span :class="row.name_BillingItemDetailsId.indexOf('&\#')>-1 ? 'errTxt' : ''" v-if="row.name_BillingItemDetailsId">{{ row.name_BillingItemDetailsId.replace('&\#','') }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="ownershipMonth" label="费用月份" min-width="100px" fit :show-overflow-tooltip="true">
            <template slot-scope="{row}">
              <span :class="row.ownershipMonth.indexOf('&\#')>-1 ? 'errTxt' : ''" v-if="row.ownershipMonth">{{ row.ownershipMonth.replace('&\#','') }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="amount" label="开票金额" min-width="140px" fit :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column align="center" prop="name" label="结算单剩余待开金额" min-width="160px" fit :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column align="center" prop="name_SubjectOfLegalAffairsId" label="商务合同主体" min-width="160px" fit :show-overflow-tooltip="true">
            <template slot-scope="{row}">
              <span :class="row.name_SubjectOfLegalAffairsId.indexOf('&\#')>-1 ? 'errTxt' : ''" v-if="row.name_SubjectOfLegalAffairsId">{{ row.name_SubjectOfLegalAffairsId.replace('&\#','') }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="name_InvoiceTitle" label="开票抬头" min-width="100px" fit :show-overflow-tooltip="true">
            <template slot-scope="{row}">
              <span :class="row.name_InvoiceTitle.indexOf('&\#')>-1 ? 'errTxt' : ''" v-if="row.name_InvoiceTitle">{{ row.name_InvoiceTitle.replace('&\#','') }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="isNaturalPerson" label="是否自然人" min-width="100px" fit :show-overflow-tooltip="true">
            <template slot-scope="{row}">
              <span>{{ row.isNaturalPerson == 1 ? '是' : '否' }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="ratepayerNo" label="纳税人识别号" min-width="100px" fit :show-overflow-tooltip="true">
            <template slot-scope="{row}">
              <span :class="row.ratepayerNo.indexOf('&\#')>-1 ? 'errTxt' : ''" v-if="row.ratepayerNo">{{ row.ratepayerNo.replace('&\#','') }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="businessAddress" label="营业地址" min-width="100px" fit :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column align="center" prop="bankOfDeposit" label="开户银行" min-width="100px" fit :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column align="center" prop="accountNumber" label="银行账户" min-width="100px" fit :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column align="center" prop="newEmail" label="客户邮箱" min-width="100px" fit :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column align="center" prop="billingNote" label="开票备注（显示在发票上）" min-width="180px" fit :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column align="center" prop="remark" label="申请备注（提示财务注意）" min-width="180px" fit :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column align="center" prop="accountType" label="账户类型" min-width="100px" fit :show-overflow-tooltip="true">
            <template slot-scope="{row}">
              <span>{{ row.accountType == 0 ? '基本户' : row.accountType == 0 ? '一般户' : ''}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="openingBank" label="销方开户行" min-width="100px" fit :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column align="center" prop="bankAccount" label="销方账号" min-width="100px" fit :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column align="center" prop="identification" label="铁建发票标识" min-width="100px" fit :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column align="center" label="操作" width="100px" fixed="right">
            <template slot-scope="{row,$index}">
              <div class="injuryTabBtn">
                <el-button type="text" size="small" @click="edit(row,$index)">修改</el-button>
                <el-button type="text" size="small" @click="del($index)">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <div class="btn_box">
          <el-button @click="cancel()">返 回</el-button>
          <el-button type="success" @click="beforeSubmit()" :loading="isBtnLoading" :disabled="isSuccess || tableData.length==0">提交申请</el-button>
        </div>
      </div>
    </div>

    <el-dialog title="批量导入" :visible.sync="showImport" width="500px">
      <el-form label-width="100px">
        <el-form-item label="批量导入" prop="imp">
          <el-upload class="upload-demo" ref="file" action="#" :on-change="success_handle" :auto-upload="false" :limit="1" :on-remove="handleFileRemove" :on-exceed="handleExceed" :file-list="fileList">
            <el-button size="small" type="primary">导入</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="导入模板">
          <div class="blueName cp" @click="downTemp">下载模板</div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showImport = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmImport" :loading="isBtnLoading">导 入</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="type=='add' ? '添加行' : '修改'" :visible.sync="showAddLine" width="1100px">
      <div v-if="showAddLine">
        <el-form label-width="120px" :model="lineForm" ref="lineForm" :inline="true">
          <div>
            <el-form-item label="项目/部门" prop="imp">
              <div class="i_radio_box">
                <el-radio-group v-model="lineForm.type">
                  <el-radio :label="1">项目</el-radio>
                  <el-radio :label="2">内部部门</el-radio>
                </el-radio-group>
                <el-select v-model="lineForm.ownershipId" v-if="lineForm.type == 1" placeholder="请选择项目" @change="changeProject" size="small" filterable clearable>
                  <el-option v-for="item in projectList" :key="item.Id" :label="item.StrprojectName" :value="item.Projectid"></el-option>
                </el-select>
                <el-cascader v-if="lineForm.type == 2" v-model="dedpartDiaVal" size="small" :props="props" ref="depart" clearable filterable :options="departList" placeholder="请选择部门" @change="departChange2" style="width: 205px"></el-cascader>
              </div>
            </el-form-item>
          </div>
          <el-form-item label="商务合同主体">
            <el-select v-model="lineForm.subjectOfLegalAffairsId" placeholder="" size="small" clearable filterable @change="changeSub">
              <el-option v-for="(item, index) in legList" :key="index" :label="item.value" :value="item.key"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="账户类别:">
            <div style="width: 300px;">
              <el-radio-group v-model="lineForm.accountType" @input="changeAccountType">
                <el-radio :label="0">基本户</el-radio>
                <el-radio :label="1">一般户</el-radio>
              </el-radio-group>
            </div>
          </el-form-item>
          <el-form-item label="销方开户行/账号:" v-if="lineForm.accountType==1">
            <el-select v-model="lineForm.bankAccount" placeholder="" size="small" @change="changeBankAccount" filterable clearable style="width: 205px">
              <el-option v-for="item in accountList" :key="item.value" :label="item.key" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="费用月份">
            <el-date-picker v-model="lineForm.ownershipMonth" value-format="yyyy-MM" type="month" size="small" placeholder="" style="width: 205px;"></el-date-picker>
          </el-form-item>
          <el-form-item label="开票抬头:">
            <el-select v-model="invoiceTitle2" placeholder="" size="small" clearable filterable @change="changeInvoiceTitle2" value-key="id">
              <el-option v-for="(item, index) in invoiceTitles" :key="index" :label="item.accountName" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-checkbox v-model="lineForm.isNaturalPerson" :true-label="1" :false-label="0" style="margin-left: 20px" @change="(val) => changeIsp2(val, i)">是否自然人</el-checkbox>
          </el-form-item>
          <el-form-item label="使用新抬头:">
            <el-input v-model="lineForm.newInvoiceTitle" size="small" clearable></el-input>
          </el-form-item>
          <el-form-item label="纳税人识别号:" prop="ratepayerNo">
            <el-input v-model="lineForm.ratepayerNo" size="small" clearable></el-input>
          </el-form-item>
          <el-form-item label="营业地址:">
            <el-input v-model="lineForm.businessAddress" size="small" clearable></el-input>
          </el-form-item>
          <el-form-item label="开户行:">
            <el-input v-model="lineForm.bankOfDeposit" size="small" clearable></el-input>
          </el-form-item>
          <el-form-item label="账号:">
            <el-input v-model="lineForm.accountNumber" size="small" clearable></el-input>
          </el-form-item>
          <el-form-item label="电话:">
            <el-input v-model="lineForm.telephone" size="small" clearable></el-input>
          </el-form-item>
          <el-form-item label="发票项目:">
            <el-select v-model="lineForm.invoiceItem" placeholder="" size="small" @change="(val)=>{changeInvoiceItem(val)}">
              <el-option v-for="(item,index) in invItemList" :key="
              index" :label="item.label" :value="item.val"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="发票类型:">
            <el-select v-model="lineForm.ticketTypeId" placeholder="" size="small" @change="(val)=>{changeTicketType(val)}">
              <el-option v-for="item in ticketTypeList" :key="item.key" :label="item.value" :value="item.key"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开票内容:">
            <el-select v-model="lineForm.billingItemDetailsId" placeholder="" size="small" @change="(val)=>{changeBillingItemDetailsId(val)}" filterable>
              <el-option v-for="item in BillingConList" :key="item.key" :label="item.value " :value="item.key"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开票金额:">
            <el-input v-model="lineForm.amount" type="number" size="small" clearable></el-input>
          </el-form-item>
          <el-form-item label="规格型号:">
            <el-input v-model="lineForm.specification" size="small" clearable></el-input>
          </el-form-item>
          <el-form-item label="单位:">
            <el-input v-model="lineForm.unit" size="small" clearable></el-input>
          </el-form-item>
          <el-form-item label="数量:">
            <el-input v-model="lineForm.quantity" type="number" size="small" clearable></el-input>
          </el-form-item>
          <!-- <el-form-item label="单价:">
            <el-input v-model="lineForm.newEmail" size="small" clearable></el-input>
          </el-form-item> -->
          <el-form-item label="客户邮箱:">
            <el-input v-model="lineForm.newEmail" size="small" clearable></el-input>
          </el-form-item>
          <el-form-item label="铁建发票标识:">
            <el-input v-model="lineForm.identification" size="small" clearable></el-input>
          </el-form-item>
          <el-form-item label="开票备注:">
            <el-input v-model="lineForm.billingNote" size="small" clearable></el-input>
          </el-form-item>
          <el-form-item label="申请备注:">
            <el-input v-model="lineForm.remark" size="small" clearable></el-input>
          </el-form-item>
          <el-form-item label="土地增值税项目编号:" v-if="isBuild">
            <el-input v-model="lineForm.specification" size="small" clearable></el-input>
          </el-form-item>
          <el-form-item label="建筑服务发生地:" v-if="isBuild">
            <el-input v-model="lineForm.specification" size="small" clearable></el-input>
          </el-form-item>
          <el-form-item label="详细地址:" v-if="isBuild">
            <el-input v-model="lineForm.specification" size="small" clearable></el-input>
          </el-form-item>
          <el-form-item label="建筑项目名称:" v-if="isBuild">
            <el-input v-model="lineForm.specification" size="small" clearable></el-input>
          </el-form-item>
          <el-form-item label="跨地市标志:" v-if="isBuild">
            <el-input v-model="lineForm.specification" size="small" clearable></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showAddLine = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmAdd" :loading="isBtnLoading">确 认</el-button>
      </span>
    </el-dialog>

    <el-dialog title="错误提示" :visible.sync="showErrMsg" width="500px">
      <div>{{errMsg}}</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showErrMsg = false" size="small">关 闭</el-button>
      </span>
    </el-dialog>

    <el-dialog title="异常提示" :visible.sync="showAbnormal" width="500px">
      <div>异常提示：第 {{ abnormalList }}行 “是否自然人” 为 “是”，“纳税人识别号”不为空，请确认是否继续？</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showAbnormal = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="submit" :loading="isBtnLoading">确 认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import {
    freqz
  } from "mathjs";
  import xz from "./../../common";
  import FUN from "./../../fun";
  import checkPermission from '@/utils/permission' // 权限判断函数
  export default {
    data() {
      return {
        projectList: [],
        // 部门列表
        departList: [],
        legList: [],
        invoiceTitles: [],
        props: {
          label: 'strorganname',
          value: 'strorgancode',
          children: 'children',
          checkStrictly: true
        },
        showErrMsg: false,
        tableHeight: 0,
        tableLoading: false,
        tableData: [],
        total: 0,
        multipleSelection: [],
        laloading: false,
        roleType: localStorage.loginRoletype,
        f1Enable: 0,
        f2Enable: 0,
        f3Enable: 0,
        isBuild: false,
        titleType: null,
        invoiceTitle: '',
        impForm: {
          excelPath: "",
          fillIn_1: {
            type: null, //归属类型1：项目2：部门
            ownershipId: ""
          },
          fillIn_2: {
            subjectOfLegalAffairsId: ""
          },
          fillIn_3: {
            isNaturalPerson: 0,
            invoiceTitle: "",
            newInvoiceTitle: "",
            ratepayerNo: "",
            businessAddress: "",
            bankOfDeposit: "",
            accountNumber: "",
            telephone: ""
          },
          isConsolidatedBilling: false
        },
        isPolymerization: true,
        showImport: false,
        dedpartDiaVal: '',
        dedpartDiaVal2: '',
        fileList: [],
        isBtnLoading: false,
        lineForm: {},
        type: '',
        index: 0,
        showAddLine: false,
        invItemList: [{
          label: '服务费',
          val: 1
        }, {
          label: '劳务费',
          val: 2
        }, {
          label: '管理费',
          val: 3
        }, {
          label: '工资',
          val: -1
        }, {
          label: '社保',
          val: -2
        }, {
          label: '公积金',
          val: -3
        }, {
          label: '个税',
          val: -4
        }],
        ticketTypeList: [],
        BillingConList: [],
        invoiceTitle2: '',
        errMsg: null,
        accountList: [],
        isSuccess: false,
        showAbnormal: false,
        abnormalList: [],
        impRule: {
          'fillIn_1.ownershipId': {
            required: true,
            message: "请选择项目或部门",
            trigger: "change",
          },
          'fillIn_2.subjectOfLegalAffairsId': {
            required: true,
            message: "请选择主体",
            trigger: "change",
          },
          'fillIn_3.ratepayerNo': {
            required: true,
            message: "请输入纳税人识别号",
            trigger: "blur",
          },
        },
      }
    },
    created() {
      // 部门列表
      this.calHeight();
      this.getProNameList();
      // 部门列表
      this.getDepartList();
      // this.getlegalsubjectlist();
    },
    methods: {
      checkPermission,
      calHeight() {
        this.tableHeight = Number(document.body.clientHeight);
      },
      // 获取项目列表
      getProNameList() {
        let data = {
          searchVal: "",
          pageSize: 100000000,
          pageNum: 1,
        };
        xz.getplancomrecordprojectlist(data, localStorage.loginRoletype).then(
          (res) => {
            // console.log('项目名称列表', res)
            if (res.status == "ok") {
              this.projectList = res.data;
            } else {
              this.projectList = [];
            }
          }
        );
      },
      // 获取部门列表
      getDepartList() {
        xz.getorganstr('', localStorage.loginRoletype, {
          strIsDisable: 1
        }).then(res => {
          if (res.status == 'ok') {
            this.departList = res.msg.parent[0].children
          } else {
            this.departList = []
          }
        })
      },
      //获取法务主体列表
      getlegalsubjectlist() {
        let data = {
          keyWord: '',
          pageSize: '10000',
          UserId: Cookies.get("userid-b")
        }
        xz.BasicFun(data, 'GetSubjectOfLegalAffairs').then(res => {
          if (res.status == 'ok') {
            this.legList = res.data;
          } else {
            this.legList = [];
          }
        })
      },
      departChange(val) {
        if (val) {
          this.impForm.fillIn_1.ownershipId = val[val.length - 1];
          this.getDetail("");
        } else {
          this.impForm.fillIn_1.ownershipId = "";
        }
      },
      // 下载模板
      downTemp() {
        let path = this.$store.state.EMP.tablePath + "excel/9c895257-5e33-4888-9bd8-adb6df000386/E20260421170358852.xlsx";
        const aTag = document.createElement('a')
        aTag.href = path;
        aTag.download = "批量导入开票模板.xlsx";
        aTag.click();
      },
      // 表格多选
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      //初始化
      getDetail() {
        let data;
        if (this.showAddLine) {
          data = {
            type: this.lineForm.type,
            ownershipId: this.lineForm.ownershipId,
            isinterior: false
          };
        } else {
          data = {
            type: this.impForm.fillIn_1.type,
            ownershipId: this.impForm.fillIn_1.ownershipId,
            isinterior: false
          };
        }
        xz.IvoiceFun(data, "GetBatchInvoiceLoad").then((res) => {
          if (res.status == "ok") {
            this.invoiceTitles = res.data.invoiceTitles;
            // this.finalStatement[0].list = res.data.finalStatement;
            // this.emailList = res.data.projectEmail;
            this.legList = res.data.subjectOfContract;
          }
        });

      },
      changeInvoiceTitle(val) {
        if (val.id != undefined && val.id) {
          this.$set(this.impForm.fillIn_3, 'invoiceTitle', val.id);
          this.$set(this.impForm.fillIn_3, 'accountNumber', val.bankAccount);
          this.$set(this.impForm.fillIn_3, 'ratepayerNo', val.account);
          this.$set(this.impForm.fillIn_3, 'businessAddress', val.businessAddress);
          this.$set(this.impForm.fillIn_3, 'bankOfDeposit', val.openingBank);
          this.$set(this.impForm.fillIn_3, 'telephone', val.phoneNum);
        }
      },
      changeInvoiceTitle2(val) {
        console.log(val)
        if (val.id != undefined && val.id) {
          this.lineForm.name_InvoiceTitle = val.accountName
          this.lineForm.invoiceTitle = val.id;
          this.lineForm.accountNumber = val.bankAccount;
          this.lineForm.ratepayerNo = val.account;
          this.lineForm.businessAddress = val.businessAddress;
          this.lineForm.bankOfDeposit = val.openingBank;
          this.lineForm.telephone = val.phoneNum;
        }
      },
      changeNewTitle(val) {
        if (val != undefined && val) {
          this.impForm.fillIn_3.invoiceTitle = '';
          this.invoiceTitle = '';
        }
      },
      batchImport() {
        this.impForm.excelPath = '';
        this.fileList = [];
        this.showImport = true;
      },
      handleExceed() {
        this.$message.warning(`只能导入 1 个文件`);
      },
      // 删除
      handleFileRemove() {
        this.impForm.excelPath = '';
      },
      // 上传
      success_handle(file) {
        const formData = new FormData();
        formData.append("pagename", "empexcel");
        formData.append("action", "save");
        formData.append("userid", Cookies.get("userid-b"));
        formData.append("entid", Cookies.get("userid-b"));
        formData.append("excel", file.raw, file.name);
        console.log("formData", formData, file);
        xz.uploadCert(formData).then((res) => {
          if (res) {
            this.impForm.excelPath = res;
          } else {
            this.impForm.excelPath = ''
          }
        });
      },
      confirmImport() {
        this.isBtnLoading = true;
        let d = {
          excelPath: this.impForm.excelPath,
          fillIn_1: this.f1Enable ? this.impForm.fillIn_1 : null,
          fillIn_2: this.f2Enable ? this.impForm.fillIn_2 : null,
          fillIn_3: this.f3Enable ? this.impForm.fillIn_3 : null,
          isConsolidatedBilling: this.impForm.isConsolidatedBilling,
        }
        xz.IvoiceFun(d, "UpLoadExcelToBatchInvoice").then((res) => {
          if (res.status == 'ok') {
            this.tableData = res.data;
            this.isBtnLoading = false;
            this.showImport = false;
          } else {
            this.$message.error(res.msg);
            this.tableData = [];
            this.isBtnLoading = false;
            this.showImport = false;
          }
        })
      },
      addLine() {
        this.lineForm = {
          name_Type: null,
          name_OwnershipId: "&#项目必填",
          name_SubjectOfLegalAffairsId: "",
          name_InvoiceTitle: "",
          name_IsConsolidatedBilling: "",
          name_Amount: "",
          name_InvoiceItem: "",
          name_TicketTypeId: "",
          name_BillingItemDetailsId: "",
          name_CrossCitySigns: null,
          type: 1,
          ownershipId: null,
          subjectOfLegalAffairsId: "",
          invoiceTitle: "",
          newInvoiceTitle: "",
          ratepayerNo: "",
          businessAddress: "",
          bankOfDeposit: "",
          accountNumber: "",
          telephone: "",
          isConsolidatedBilling: 0,
          newEmail: "",
          identification: null,
          billingNote: "",
          remark: "",
          ownershipMonth: "",
          amount: 0,
          invoiceItem: "",
          ticketTypeId: null,
          billingItemDetailsId: null,
          landValueTaxNo: null,
          buildingServiceSite: null,
          detailedAddress: null,
          buildingName: null,
          crossCitySigns: null,
          specification: '',
          unit: '',
          quantity: '',
          bankAccount: '',
          openingBank: '',
          accountType: 0,
        }
        this.type = 'add';
        this.isBuild = false;
        this.showAddLine = true;
      },
      edit(row, index) {
        this.lineForm = row;
        this.index = index;
        this.type = 'edit';
        this.showAddLine = true;
      },
      del(index) {
        this.tableData.splice(index, 1);
      },
      changeProject(val) {
        this.getDetail();
        const item = this.projectList.find(e => e.Projectid == val);
        this.lineForm.name_OwnershipId = item.StrprojectName;
      },
      departChange2(val) {
        let checkedNode = this.$refs["depart"].getCheckedNodes();
        if (val) {
          this.lineForm.ownershipId = val[val.length - 1];
          this.lineForm.name_OwnershipId = checkedNode[0].label;
          this.getDetail("");
        } else {
          this.lineForm.ownershipId = '';
          this.lineForm.name_OwnershipId = '';
        }
      },
      changeSub(val) {
        const item = this.legList.find(e => e.key == val);
        this.lineForm.name_SubjectOfLegalAffairsId = item.value;
      },
      changeInvoiceItem(val) {
        this.lineForm.billingItemDetailsId = '';
        this.lineForm.ticketTypeId = '';
        this.GetTicketTypeForInvoice(this.lineForm.subjectOfLegalAffairsId);
        const item = this.invItemList.find(e => e.val == val);
        this.lineForm.name_InvoiceItem = item.label;
      },
      //获取票种
      GetTicketTypeForInvoice(id) {
        let iskc;
        if (this.lineForm.invoiceItem > 0) {
          iskc = false
        } else {
          iskc = true;
        }
        xz.GetTicketTypeForInvoice(id, iskc).then(res => {
          if (res.status == 'ok') {
            this.ticketTypeList = res.data
          } else {
            this.ticketTypeList = [];
          }
        })
      },
      //选择票种
      changeTicketType(val) {
        this.lineForm.billingItemDetailsId = '';
        const ticketType = this.ticketTypeList.find(e => e.key == val);
        this.lineForm.name_TicketTypeId = ticketType.value;
        let iskc;
        if (this.lineForm.invoiceItem > 0) {
          iskc = false
        } else {
          iskc = true;
        }
        xz.GetBillingItemDetailsForInvoice(this.lineForm.subjectOfLegalAffairsId, val, this.lineForm.ownershipId, iskc).then(res => {
          if (res.status == 'ok') {
            this.BillingConList = res.data
          } else {
            this.BillingConList = [];
          }
        })
      },
      changeBillingItemDetailsId(val) {
        const item = this.BillingConList.find(e => e.key == val);
        this.lineForm.name_BillingItemDetailsId = item.value;
        if (lineForm.name_BillingItemDetailsId.indexOf('建筑服务') > -1) {
          this.isBuild = true;
        } else {
          this.isBuild = false;
        }
      },
      confirmAdd() {
        if (this.type == 'add') {
          this.tableData.push(this.lineForm)
        } else {
          this.tableData[this.index] = this.lineForm;
        }
        this.showAddLine = false;
      },
      beforeSubmit() {
        let canSubmit = true;
        let noAbnormal = true;
        let abnormalList = [];
        this.tableData.forEach((element, index) => {
          this.$set(element, 'index', index + 1)
          if (element.name_InvoiceTitle.indexOf('&#') > -1 || element.ratepayerNo.indexOf('&#') > -1 || element.ownershipMonth.indexOf('&#') > -1) {
            canSubmit = false
          }
          if (element.isNaturalPerson == 1 && element.ratepayerNo) {
            noAbnormal = false;
            abnormalList.push(index + 1)
          }
          if (index == this.tableData.length - 1) {
            if (canSubmit) {
              if (noAbnormal) {
                this.submit();
              } else {
                this.abnormalList = abnormalList.toString();
                this.showAbnormal = true;
              }
            } else {
              this.isBtnLoading = false;
              this.$message.error('请检查表格内红字错误')
            }
          }
        });
      },
      submit() {
        let d = {
          data: this.tableData,
          founder: Cookies.get("userid-b"),
          isPolymerization: this.isPolymerization
        }
        this.isBtnLoading = true;
        xz.IvoiceFun(d, 'SetBatchInvoiceSave').then(res => {
          if (res.status == 'ok') {
            this.$message.success("提交成功！");
            this.isSuccess = true;
            this.isBtnLoading = false;
            this.showAbnormal = false;
            setTimeout(() => {
              this.cancel()
            }, 1000);
          } else {
            console.log(res.data)
            this.errMsg = res.data;
            this.showErrMsg = true;
            this.$message.error(res.msg);
            this.isBtnLoading = false;
          }
        })
      },
      cancel() {
        window.close()
      },
      changeEnable(val) {
        if (val == 1) {
          this.impForm.fillIn_1.type = 1
        } else {
          this.impForm.fillIn_1.type = null
        }
      },
      changeEnable2(val) {
        if (val == 1) {
          this.titleType = 1
        } else {
          this.titleType = null
        }
      },
      changeIsp(val) {
        console.log(val)
        if (val == 3) {
          this.impForm.fillIn_3.isNaturalPerson = 1;
          this.impForm.fillIn_3.newInvoiceTitle = '个人';
        } else {
          this.impForm.fillIn_3.isNaturalPerson = 0;
          this.impForm.fillIn_3.newInvoiceTitle = '';
        }
      },
      changeIsp2(val) {
        if (val) {
          this.lineForm.isNaturalPerson = 1;
          this.lineForm.newInvoiceTitle = '个人';
          this.invoiceTitle2 = '';
          this.lineForm.invoiceTitle = '';
        } else {
          this.lineForm.details[i].newInvoiceTitle = '';
          this.lineForm.isNaturalPerson = 0;
        }
      },
      changeAccountType() {
        if (this.lineForm.accountType == 1) {
          let d = {
            keyWord: "",
            pageSize: 100,
            legalsubid: this.lineForm.subjectOfLegalAffairsId,
            UserId: Cookies.get("userid-b")
          }
          xz.BasicFun(d, "GetGeneralAccount").then((res) => {
            if (res.status == "ok") {
              this.accountList = res.data;
            } else {
              accountList = [];
            }
          });
        }
      },
      changeBankAccount(val) {
        let item = this.accountList.find(e => e.value == val);
        this.lineForm.openingBank = item.key;
      },
    }
  }
</script>

<style scoped>
  .errTxt {
    color: red;
    font-weight: bold;
  }

  .btn_box {
    display: flex;
    justify-content: center;
    margin-top: 30px;
    padding-bottom: 20px;
  }

  .i_radio_box {
    display: -webkit-box;
    /* align-items: center; */
  }

  .i_box {
    margin-left: 30px;
  }


  .ftabs {
    background: #fff;
    width: 99%;
  }

  .fillIn {
    padding-left: 30px;
  }

  .r_act_item {
    padding-left: 30px;
    margin-top: 20px;
  }

  .tips {
    padding: 20px 0 10px 30px;
    color: red;
    font-size: 14px;
  }
</style>

<style>
  .page_batchImportInv .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_batchImportInv .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_batchImportInv .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_batchImportInv .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_batchImportInv .el-radio {
    margin-right: 15px;
  }

  .page_batchImportInv .el-form-item {
    margin-bottom: 8px;
  }

  .page_batchImportInv .el-form-item__error {
    top: 33px;
  }
</style>